export default __webpack_public_path__ + "static/media/image.d9d40a11.png";